if(document.querySelector('.js-validate-email')) {
  const emailInputs = document.querySelectorAll('.js-validate-email');
  emailInputs.forEach(emailInput => {
    emailInput.addEventListener('input', () => {
      const emailInputvalue = emailInput.value;
      const feedbackElement = emailInput.nextElementSibling;
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailInputvalue.match(emailRegex)) {
        feedbackElement.innerHTML = ""; // Email is valid
        if(emailInput.classList.contains('email-error')) {
            emailInput.classList.remove('email-error');
        }
      } else {

        emailInput.classList.add('email-error');

        feedbackElement.innerHTML = `
            <svg class="icon icon-alert-circle" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 3.33341C6.31812 3.33341 3.33335 6.31818 3.33335 10.0001C3.33335 13.682 6.31812 16.6667 10 16.6667C13.6819 16.6667 16.6667 13.682 16.6667 10.0001C16.6667 6.31818 13.6819 3.33341 10 3.33341ZM10 1.66675C14.6024 1.66675 18.3334 5.39771 18.3334 10.0001C18.3334 14.6025 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6025 1.66669 10.0001C1.66669 5.39771 5.39765 1.66675 10 1.66675ZM9.16669 10.8334V5.83342H10.8334V10.8334H9.16669ZM10 12.5001C10.4603 12.5001 10.8334 12.8732 10.8334 13.3334C10.8334 13.7937 10.4603 14.1667 10 14.1667C9.53978 14.1667 9.16669 13.7937 9.16669 13.3334C9.16669 12.8732 9.53978 12.5001 10 12.5001Z" fill="currentColor"/>
            </svg>
            Please enter a valid email address
        `;
      }
    })
  });
}
